import swal from "sweetalert";
import './index.css'
const Alert = (icon, message) => {
  swal({
    icon: icon,
    text: message,
    button: false,
    timer: 2000,
    customClass: {
      popup: 'my-popup-class', // Define your custom class here
    },
  });
};

const DeleteAlert = (message) => {
  return new Promise((resolve) => {
    swal({
      title: "Are you sure?",
      text: message ? message : "You want to delete this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnClickOutside: false,
    }).then((deleted) => {
      if (deleted) {
        resolve(true);
      }
      resolve(false);
    });
  });
};

const UpdateAlert = () => {
  return new Promise((resolve) => {
    swal({
      title: "Are you sure?",
      text: "You want to update this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnClickOutside: false,
    }).then((deleted) => {
      if (deleted) {
        resolve(true);
      }
      resolve(false);
    });
  });
};

const ConfirmAlert = (message, title = "Confirm", confirmText = "OK") => {
  return new Promise((resolve) => {
    swal({
      title,
      text: message,
      icon: "warning",
      buttons: ["Cancel", confirmText],
      dangerMode: false,
      closeOnClickOutside: false,
    }).then((confirmed) => {
      if (confirmed) {
        resolve(true);
      }
      resolve(false);
    });
  });
};

export { DeleteAlert, UpdateAlert, ConfirmAlert };

export default Alert;
